<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="dedication"><a id="page_v"></a><em>For Kate and Robin, and for Véronique, Jennifer, Tim, Sean, and everyone at Henry Holt Books for Young Readers, with my deepest thanks for your insight, guidance, talent, tact, and, most of all, your unswerving enthusiasm and support: How did I get so lucky?</em></p>
<p class="dedication"><em>For N and K and C, the most splendiferously, awesomely wonderful young adults on the planet</em></p>
<p class="dedication"><em>And always, for Scott</em></p>
<p class="linespace"> </p>
<p class="image"><img alt="Image" src="images/f000v.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a04e29e2